import { type Clip } from '@air/api/types';

export const getClipAspectRatio = (clip: Pick<Clip, 'darHeight' | 'darWidth' | 'height' | 'width'>) => {
  if (clip.darHeight && clip.darWidth) {
    return clip.darWidth / clip.darHeight;
  }

  return clip.width / clip.height;
};
